// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.remark_Edu-C .remark-content {\n    text-align: center\n}\n.remark_Edu-C .remark-content .remark-title {\n    font-weight: 400\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"remark": "remark_Edu-C"
};
module.exports = ___CSS_LOADER_EXPORT___;
